import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { createPageUrl } from '@/utils';
import { Sparkles, Eye, Boxes } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageProvider';

const features = [
{
  icon: Eye,
  title: 'Realtà Virtuale Immersiva',
  description: 'Visualizza il tuo progetto prima ancora di iniziare i lavori con visori Meta Quest 3'
},
{
  icon: Boxes,
  title: 'Progettazione 3D',
  description: 'Ogni dettaglio è studiato in 3D per garantire il risultato perfetto'
},
{
  icon: Sparkles,
  title: 'Chiavi in Mano',
  description: 'Dalla progettazione alla consegna, pensiamo a tutto noi'
}];


export default function AboutSection() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#f8f8f8] py-14 md:py-32">
      <div className="mx-auto max-w-[1800px] px-6 md:px-12 lg:px-20">
        {/* Main Section with VR Emphasis */}
        <div className="relative mb-0 overflow-hidden bg-white md:mb-20 md:rounded-3xl md:bg-gradient-to-br md:from-white md:to-[#f8f8f8]">
          {/* VR Background Image on Right */}
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
            className="absolute right-0 top-0 bottom-0 w-1/2 lg:w-2/5 pointer-events-none hidden lg:block">

            <img
              src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/696b8a6ae79eec44c999be35/8baa13c4a_immagine_2026-01-17_144426890-removebg-preview.png"
              alt="Cliente con visore VR Meta Quest 3"
              width="720"
              height="900"
              loading="lazy"
              decoding="async"
              className="h-full w-auto object-contain object-right opacity-90" />

          </motion.div>

          {/* Decorative gradient overlays */}
          <div className="absolute right-0 top-0 bottom-0 w-1/3 bg-gradient-to-l from-transparent via-[#9c8b7a]/5 to-transparent pointer-events-none" />
          
          <div className="relative z-10 px-6 py-10 md:px-12 md:py-16 lg:px-20 lg:py-24">
            <div className="max-w-2xl">
              {/* Text Content */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}>

                <h2 className="mb-6 text-balance font-serif text-[32px] font-light leading-tight text-[#2d2d2d] md:text-5xl">
                  {t('Progettazione Con Realtà Virtuale')}
                </h2>
                <div className="w-16 h-px bg-[#9c8b7a] mb-8" />
                
                


                
                <p className="mb-6 text-[17px] leading-[1.75] text-[#5f5f5f] md:text-lg">
                  {t("Integriamo la realtà virtuale immersiva nel processo progettuale per offrire un'esperienza diretta e consapevole degli spazi prima della loro realizzazione. Attraverso visori VR di ultima generazione, è possibile entrare nel progetto, percepirne proporzioni, luce e materiali in scala reale e valutare con maggiore precisione ogni scelta architettonica.")}
                </p>
                
                <p className="text-[17px] leading-[1.75] text-[#5f5f5f] md:text-lg">
                  {t('Uno strumento evoluto che migliora la comprensione del progetto e supporta decisioni più consapevoli.')}
                </p>
                <Link to={createPageUrl('Contact')} className="mt-8 inline-flex min-h-12 items-center border border-[#2d2d2d] px-6 text-sm uppercase tracking-[0.18em] text-[#2d2d2d] transition-colors duration-200 hover:bg-[#2d2d2d] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2d2d2d]">{t('Parliamo del progetto')}</Link>

                {/* Badge */}
                









              </motion.div>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return null;















          })}
        </div>
      </div>
    </section>);

}